import React from "react";

function HairFall() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#fed2a4"
        d="M0 279.528v35.789h512v-35.789c0-5.523-4.477-10-10-10H10c-5.523 0-10 4.478-10 10z"
        data-original="#fed2a4"
      ></path>
      <path
        fill="#ffbd86"
        d="M428.787 315.317H512v-35.789c0-5.523-4.477-10-10-10h-69.296c-.016 15.093-1.323 30.414-3.917 45.789z"
        data-original="#ffbd86"
      ></path>
      <path
        fill="#ffc4c8"
        d="M0 315.317h512v163.382H0z"
        data-original="#ffc4c8"
      ></path>
      <path
        fill="#fdb4ba"
        d="M428.787 315.317c-9.563 56.68-36.494 114.076-79.919 163.382H512V315.317z"
        data-original="#fdb4ba"
      ></path>
      <path
        fill="#fe99a0"
        d="M393.826 356.878c-11.682 0-22.031 6.977-27.041 17.53-5.095 10.733-14.988 15.77-25.165 15.77h-26.355c-12.536 0-24.256 6.456-30.736 17.188-5.831 9.656-16.425 16.113-28.528 16.113s-22.697-6.456-28.528-16.113c-6.48-10.732-18.2-17.188-30.736-17.188h-26.355c-10.178 0-20.07-5.038-25.165-15.77-5.01-10.553-15.359-17.53-27.041-17.53h-1.447c-11.682 0-22.031 6.977-27.041 17.53-5.095 10.733-14.988 15.77-25.165 15.77-14.656 0-28.72-10.446-28.72-33.301 0-41.561-35.8-41.561-35.8-41.561h512s-35.8 0-35.8 41.561c0 22.854-14.064 33.301-28.72 33.301-10.178 0-20.07-5.038-25.165-15.77-5.01-10.553-15.359-17.53-27.041-17.53z"
        data-original="#fe99a0"
      ></path>
      <path
        fill="#fd8087"
        d="M428.787 315.317c-2.816 16.689-7.153 33.437-12.957 50.025a31.501 31.501 0 016.485 9.066c5.095 10.733 14.988 15.77 25.166 15.77 14.656 0 28.721-10.446 28.721-33.301 0-41.561 35.8-41.561 35.8-41.561h-83.215z"
        data-original="#fd8087"
      ></path>
      <path
        fill="#fef0ae"
        d="M0 478.699h512V502c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
        data-original="#fef0ae"
      ></path>
      <path
        fill="#fee97d"
        d="M348.868 478.699a368.07 368.07 0 01-15.968 17.014 368.018 368.018 0 01-17.383 16.286H502c5.523 0 10-4.477 10-10v-23.301H348.868z"
        data-original="#fee97d"
      ></path>
      <path
        fill="#685e68"
        d="M275.983 321.978c-7.418-93.425 13.603-184.573 26.263-229.152 1.343-4.728-5.179-7.464-7.625-3.2-44.291 77.198-56.762 185.164-60.219 233.655-7.744 6.607-12.429 16.694-11.611 27.847 1.2 16.362 14.483 29.582 30.85 30.709 19.458 1.34 35.659-14.048 35.659-33.219.001-10.894-5.231-20.564-13.317-26.64z"
        data-original="#685e68"
      ></path>
      <path
        fill="#554e56"
        d="M425.88 175.602c-5.556-69.969 10.187-138.232 19.669-171.618 1.006-3.541-3.879-5.59-5.711-2.397-33.171 57.816-42.511 138.674-45.1 174.991-5.799 4.948-9.308 12.503-8.695 20.855.899 12.254 10.847 22.155 23.104 22.999 14.573 1.004 26.706-10.521 26.706-24.879.001-8.158-3.917-15.401-9.973-19.951zm-295.955 0c-5.556-69.969 10.187-138.232 19.669-171.618 1.006-3.541-3.879-5.59-5.711-2.397-33.171 57.816-42.511 138.674-45.1 174.991-5.799 4.948-9.308 12.503-8.695 20.855.899 12.254 10.847 22.155 23.104 22.999 14.573 1.004 26.706-10.521 26.706-24.879.001-8.158-3.917-15.401-9.973-19.951z"
        data-original="#554e56"
      ></path>
      <path
        fill="#fe99a0"
        d="M502.519 181.889l-16.65-16.65a7.501 7.501 0 00-10.606 0l-16.65 16.65a7.5 7.5 0 0010.606 10.607l3.847-3.847v31.844c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-31.844l3.847 3.847c1.464 1.464 3.384 2.196 5.303 2.196s3.839-.732 5.303-2.196a7.5 7.5 0 000-10.607zm-160.946-16.651a7.501 7.501 0 00-10.606 0l-16.65 16.65a7.5 7.5 0 0010.606 10.607l3.847-3.847v31.844c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-31.844l3.847 3.847c1.464 1.464 3.384 2.196 5.303 2.196s3.839-.732 5.303-2.196a7.5 7.5 0 000-10.607zm-141.229 0a7.501 7.501 0 00-10.606 0l-16.65 16.65a7.5 7.5 0 0010.606 10.607l3.847-3.847v31.844c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-31.844l3.847 3.847c1.464 1.464 3.384 2.196 5.303 2.196s3.839-.732 5.303-2.196a7.5 7.5 0 000-10.607zm-158.919 0a7.501 7.501 0 00-10.606 0l-16.65 16.65a7.5 7.5 0 0010.606 10.607l3.847-3.847v31.844c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-31.844l3.847 3.847c1.464 1.464 3.384 2.196 5.303 2.196s3.839-.732 5.303-2.196a7.5 7.5 0 000-10.607z"
        data-original="#fe99a0"
      ></path>
      <circle
        cx="479.996"
        cy="423.48"
        r="7.726"
        fill="#fd8087"
        data-original="#fd8087"
      ></circle>
      <circle
        cx="421.981"
        cy="444.78"
        r="7.726"
        fill="#fd8087"
        data-original="#fd8087"
      ></circle>
      <circle
        cx="373.928"
        cy="416.651"
        r="7.726"
        fill="#fd8087"
        data-original="#fd8087"
      ></circle>
      <circle
        cx="318.843"
        cy="444.78"
        r="7.726"
        fill="#fd8087"
        data-original="#fd8087"
      ></circle>
      <circle
        cx="32.004"
        cy="423.48"
        r="7.726"
        fill="#fd8087"
        data-original="#fd8087"
      ></circle>
      <circle
        cx="90.019"
        cy="444.78"
        r="7.726"
        fill="#fd8087"
        data-original="#fd8087"
      ></circle>
      <circle
        cx="138.072"
        cy="416.651"
        r="7.726"
        fill="#fd8087"
        data-original="#fd8087"
      ></circle>
      <circle
        cx="193.157"
        cy="444.78"
        r="7.726"
        fill="#fd8087"
        data-original="#fd8087"
      ></circle>
      <circle
        cx="256.115"
        cy="451.812"
        r="7.726"
        fill="#fd8087"
        data-original="#fd8087"
      ></circle>
    </svg>
  );
}

export default HairFall;